if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        if (prodTitle) prodTitle.addEventListener("click", () => __scrollToTop());
        if (mainImage) mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();
        this.setObserveTarget();
        this.syncWithMainProductForm();
        this.updateStickyAtcButtonText();
        this.bindQtyListeners();
        this.bindPostAddToCartRefresh();

        window.addEventListener("syncProductQuantity", () => {
          setTimeout(() => this.updateStickyAtcButtonText(), 20);
          setTimeout(() => this.updateStickyAtcButtonText(), 80);
        });

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        if (this.domNodes.select) {
          this.domNodes.select.addEventListener("change", (e) => {
            const { target } = e;
            const variantPicker = this.mainProduct.querySelector("variant-picker");
            const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
            this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
            this.currentVariant
              ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
              : this.toggleAddButton(true, window.MinimogStrings.unavailable);

            const selectedOption = target.options[target.selectedIndex];
            const selectedOptionIds = selectedOption.dataset.options.split(",").filter((id) => id);

            if (variantPicker) {
              selectedOptionIds.forEach((optionId) => {
                const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
                if (!input) return;

                const { tagName } = input;
                switch (tagName) {
                  case "OPTION":
                    input.parentNode.value = input.value;
                    break;
                  case "INPUT":
                    input.checked = true;
                    break;
                }
              });

              variantPicker.dispatchEvent(new Event("change"));
            }

            setTimeout(() => this.updateStickyAtcButtonText(), 30);
          });
        }
      }

      bindQtyListeners() {
        const stickyQtyInput =
          this.querySelector('input[name="quantity"]') ||
          this.querySelector(".m-qty-input input") ||
          this.querySelector('input[type="number"]');

        const mainQtyInput =
          this.mainProductForm?.querySelector('input[name="quantity"]') ||
          this.mainProductForm?.querySelector(".m-qty-input input") ||
          this.mainProductForm?.querySelector('input[type="number"]');

        if (stickyQtyInput && stickyQtyInput.dataset.stickyBound !== "true") {
          stickyQtyInput.dataset.stickyBound = "true";

          stickyQtyInput.addEventListener("input", () => {
            this.updateStickyAtcButtonText();
          });

          stickyQtyInput.addEventListener("change", () => {
            this.updateStickyAtcButtonText();
          });

          const stickyWrap = stickyQtyInput.closest(".m-qty-input, .m-sticky-addtocart--quantity, .m-quantity-input");
          if (stickyWrap && stickyWrap.dataset.stickyWrapBound !== "true") {
            stickyWrap.dataset.stickyWrapBound = "true";

            stickyWrap.addEventListener("click", () => {
              setTimeout(() => this.updateStickyAtcButtonText(), 30);
            });
          }
        }

        if (mainQtyInput && mainQtyInput.dataset.mainStickyBound !== "true") {
          mainQtyInput.dataset.mainStickyBound = "true";

          mainQtyInput.addEventListener("input", () => {
            setTimeout(() => this.updateStickyAtcButtonText(), 30);
          });

          mainQtyInput.addEventListener("change", () => {
            setTimeout(() => this.updateStickyAtcButtonText(), 30);
          });

          const mainWrap = mainQtyInput.closest(".m-qty-input, .m-quantity-input");
          if (mainWrap && mainWrap.dataset.mainStickyWrapBound !== "true") {
            mainWrap.dataset.mainStickyWrapBound = "true";

            mainWrap.addEventListener("click", () => {
              setTimeout(() => this.updateStickyAtcButtonText(), 50);
            });
          }
        }
      }

      bindPostAddToCartRefresh() {
        const stickyForm = this.querySelector("form");

        const refreshStickyState = () => {
          const stickyQtyInput =
            this.querySelector('input[name="quantity"]') ||
            this.querySelector(".m-qty-input input") ||
            this.querySelector('input[type="number"]');

          const mainQtyInput =
            this.mainProductForm?.querySelector('input[name="quantity"]') ||
            this.mainProductForm?.querySelector(".m-qty-input input") ||
            this.mainProductForm?.querySelector('input[type="number"]');

          if (mainQtyInput) {
            mainQtyInput.value = 1;
            mainQtyInput.setAttribute("value", "1");
            mainQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          }

          if (stickyQtyInput) {
            stickyQtyInput.value = 1;
            stickyQtyInput.setAttribute("value", "1");
            stickyQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            stickyQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          }

          this.bindQtyListeners();
          this.updateStickyAtcButtonText();
        };

        if (stickyForm && !stickyForm.dataset.stickySubmitBound) {
          stickyForm.dataset.stickySubmitBound = "true";

          stickyForm.addEventListener("submit", () => {
            setTimeout(refreshStickyState, 150);
            setTimeout(refreshStickyState, 400);
            setTimeout(refreshStickyState, 800);
          });
        }

        document.addEventListener("cart:updated", refreshStickyState);
        document.addEventListener("cart:refresh", refreshStickyState);
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector(".m-product-form");
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".m-product-form");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');

        if (!addButton || !addButtonText) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          this.updateStickyAtcButtonText();
        }

        if (!modifyClass) return;
      }

      formatMoney(cents) {
        const value = (Number(cents || 0) / 100).toFixed(2);
        return `£${value}`;
      }

      getStickyQuantity() {
        const mainQty =
          this.mainProductForm?.querySelector('input[name="quantity"]') ||
          this.mainProductForm?.querySelector(".m-qty-input input") ||
          this.mainProductForm?.querySelector('input[type="number"]');

        const stickyQty =
          this.querySelector('input[name="quantity"]') ||
          this.querySelector(".m-qty-input input") ||
          this.querySelector('input[type="number"]');

        const qty = Number(mainQty?.value || stickyQty?.value || 1);
        return qty > 0 ? qty : 1;
      }

      updateStickyAtcButtonText() {
        const productForm = this.querySelector(".m-product-form");
        if (!productForm) return;

        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButtonText) return;

        const variantId = Number(this.querySelector(this.selectors.variantIdSelect)?.value || 0);
        const variant = this.variantData.find((v) => v.id === variantId) || this.currentVariant;

        if (!variant) {
          addButtonText.textContent = window.MinimogStrings.addToCart;
          return;
        }

        const qty = this.getStickyQuantity();
        const totalPrice = Number(variant.price || 0) * qty;

        addButtonText.innerHTML = `
          <span class="frk-sticky-atc-line">
            ${window.MinimogStrings.addToCart}
            <span data-vat-price data-price-cents="${totalPrice}">
              ${this.formatMoney(totalPrice)}
            </span>
          </span>
        `;

        if (window.updateVatPrices) window.updateVatPrices();
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector(".m-product-option--dropdown-select");

        if (pickerFields) pickerFields.value = "";
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');

        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;

          this.currentVariant = e.data.variant;

          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut);

            if (this.currentVariant.available) {
              this.updateStickyAtcButtonText();
            }
          } else {
            variantInput.value = "";
            this.toggleAddButton(true, window.MinimogStrings.unavailable);
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");

        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });

        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }

        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}